import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import TermsEdit from '@/views/terms/Edit.vue';

export const termsEditRoute: RouteConfig = {
  path: 'edit/:termsId',
  name: 'termsEdit',
  component: TermsEdit,
  props: {
    edit: true
  },
  meta: {
    breadcrumb: {
      title: 'breadcrumbs.terms.add'
    }
  },
  beforeEnter: (to, from, next) => {
    store.commit('terms/setId', tryParseInt(to.params.termsId));
    store
      .dispatch('terms/get')
      .then(terms => {
        termsEditRoute.meta.breadcrumb.title = terms.name;
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać danych regulaminu.' }));
  }
};
